import Vue from 'vue';
import { Module } from 'vuex';

import { LearningPathInfo, RootState } from 'frontend/types';

interface LearningPathState {
  learningPath: LearningPathInfo;
}

const learningPaths: Module<LearningPathState, RootState> = {
  namespaced: true,
  state: {} as LearningPathState,
  getters: {},
  mutations: {
    setValue(state: LearningPathState, value: LearningPathInfo): void {
      Vue.set(state, 'learningPath', value);
    },
  },
  actions: {},
};

export default learningPaths;
